module.exports = __webpack_public_path__ + "static/media/full-logo.9997aca1.png";